export const getStepFromPath = (path: string): number => {
  const last = path.split("/").slice(-1)[0];

  return Number(last);
};
